import colorSet from "@/src/styles/color";
import typo from "@/src/styles/typography";
import { CSSProperties, HTMLAttributes, ReactNode } from "react";
import { styled } from "styled-components";
import Typo from "../../atom/Typo";

type ItemDirectionType = "horizontal" | "vertical";
type LabelWidthType = 162 | 194;

interface SectionCardRowProps extends HTMLAttributes<HTMLDivElement> {
  direction?: ItemDirectionType;
  label?: ReactNode;
  value?: ReactNode | ReactNode[];
  className?: string;
  gap?: number;
  alignItems?: CSSProperties["alignItems"];
  labelWidth?: LabelWidthType;
}

const SectionCardRow = ({
  direction = "horizontal",
  label,
  value,
  className,
  gap = 8,
  alignItems,
  labelWidth = 162,
  ...rest
}: SectionCardRowProps) => {
  const isMultipleValue = Array.isArray(value);

  return (
    <RowContainer
      data-direction={direction}
      className={className}
      $gap={gap}
      $alignItems={alignItems}
      {...rest}
    >
      <LabelParagraph className="section-label" $labelWidth={labelWidth}>{label}</LabelParagraph>

      {isMultipleValue ? (
        <MultipleValueContainer>
          {value.map((item, idx) => (
            <Typo key={idx.toString()} typoType="b7r" color="gray5" as="p">
              {item}
            </Typo>
          ))}
        </MultipleValueContainer>
      ) : (
        <SingleValueParagraph className="section-row-single-value">
          {value}
        </SingleValueParagraph>
      )}
    </RowContainer>
  );
};

export default SectionCardRow;

const MultipleValueContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SingleValueParagraph = styled.div`
  ${typo.b7r};
  color: ${colorSet.gray5};
`;

const LabelParagraph = styled.div<{ $labelWidth: LabelWidthType }>`
  ${typo.b7m};
  color: ${colorSet.gray2};
  min-width: ${({ $labelWidth }) => $labelWidth}px;
  max-width: ${({ $labelWidth }) => $labelWidth}px;
`;

const RowContainer = styled.div<{
  $gap?: number;
  $alignItems?: CSSProperties["alignItems"];
}>`
  display: flex;
  align-items: ${({ $alignItems }) => $alignItems};
  &[data-direction="horizontal"] {
    flex-direction: row;
    gap: ${({ $gap }) => $gap}px;
  }
  &[data-direction="vertical"] {
    flex-direction: column;
    gap: ${({ $gap }) => $gap}px;
  }

  ${SingleValueParagraph},${MultipleValueContainer} {
    word-break: break-all;
    &[data-direction="horizontal"] {
      text-align: right;
      flex: 1;
    }
    &[data-direction="vertical"] {
    }
  }

  &[data-direction="horizontal"] {
    ${MultipleValueContainer} {
      gap: 12px;
    }
  }
`;
